import { storeToRefs } from 'pinia'
import { useCmsConfigStore } from '@/stores/cms/cmsConfigStore'
import { useScreensaverStore } from '@/stores/screensaver/screensaverStore'
import {
  MONEY_PROCESSING_EVENT_ID,
  moneyProcessingPubSub,
  type DMPocketMoneyEventData
} from '@nsftx/seven-client-retail-vue-dm'
import { useIdleTimer } from '@nsftx/seven-nxg-retail-vue-sdk'

const handleMoneyProcessingEvent = (_topic: string, data?: DMPocketMoneyEventData) => {
  if (!data?.type) return

  if (data.type === 'moneyProcessing') {
    useScreensaverStore().hideScreensaver()
  }
}

const handleScreensaverOnScanEvent = () => {
  useScreensaverStore().hideScreensaver()
}

const handleScreensaverShowTriggers = () => {
  const screensaverStore = useScreensaverStore()
  const { showScreensaver } = screensaverStore
  const { isScreensaverEnabled, hasScreensaverData, screensaverIdleTimer } =
    storeToRefs(screensaverStore)

  const idleTimerDuration = 120_000
  const idleTimerTransitionDelay = 7_000

  if (isScreensaverEnabled.value && hasScreensaverData.value) {
    showScreensaver()

    screensaverIdleTimer.value = useIdleTimer({
      duration: idleTimerDuration,
      transitionDelay: idleTimerTransitionDelay,
      onEnd: showScreensaver,
      onReset: () => {},
      onTick: () => {}
    })
    screensaverIdleTimer.value?.startIdleTimer()
  }
}

const handleScreensaverHideTriggers = () => {
  const { isScreensaverEnabled, hasScreensaverData } = storeToRefs(useScreensaverStore())

  if (isScreensaverEnabled.value && hasScreensaverData.value) {
    // nfc card reader events not available yet
    moneyProcessingPubSub.subscribe(MONEY_PROCESSING_EVENT_ID, handleMoneyProcessingEvent)
  }
}

const initScreensaver = () => {
  const { setScreensaverData } = useScreensaverStore()
  const cmsScreensaverData = useCmsConfigStore().cmsConfig?.appSettings.screensaver || null

  setScreensaverData(cmsScreensaverData)
  handleScreensaverShowTriggers()
  handleScreensaverHideTriggers()
}

export { initScreensaver, handleScreensaverOnScanEvent }
